module.exports = __webpack_public_path__ + "static/media/enterprise_info.b9a9ecb9.svg";